import Typo from "../Typo/Typo";
import "./Card.css";

export default function Card({
  className,
  children,
  onClick = null,
  pop = false,
  row = false,
  style,
}) {
  return (
    <div
      style={style}
      className={[
        "CardNew",
        className,
        onClick ? "clickable" : "",
        pop ? "pop" : "",
        row ? "row" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export function CardText({ heading, subheading, children, row = false }) {
  return (
    <div className={["Card-text", row ? "row" : ""].filter(Boolean).join(" ")}>
      {heading && <CardTextHeading title={heading}>{heading}</CardTextHeading>}
      {subheading && (
        <CardTextSubheading title={subheading}>{subheading}</CardTextSubheading>
      )}
      {children}
    </div>
  );
}

export function CardTextHeading({ children, title }) {
  return (
    <Typo variant="body5" title={title || children}>
      {children}
    </Typo>
  );
}

export function CardTextSubheading({ children, title }) {
  return (
    <Typo
      variant="body4"
      className="Card-text-subheading"
      title={title || children}
    >
      {children}
    </Typo>
  );
}

export function Cards({ className, children }) {
  return (
    <div className={["CardsNew", className].filter(Boolean).join(" ")}>
      {children}
    </div>
  );
}
